module.exports = __webpack_public_path__ + "static/media/team6.013cb618.png";